import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

class ProductVariantDescription extends Component {
  requiredRefs = ['content'];

  connectedCallback() {
    super.connectedCallback();
    const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], dialog');
    if (!target) return;
    target.addEventListener(ThemeEvents.variantUpdate, this.updateDescription);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], dialog');
    if (!target) return;
    target.removeEventListener(ThemeEvents.variantUpdate, this.updateDescription);
  }

  updateDescription = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    }

    if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const selector = this.dataset.blockId
      ? `variant-description-component[data-block-id="${this.dataset.blockId}"]`
      : 'variant-description-component';

    const newDescription =
      event.detail.data.html.querySelector(selector) || event.detail.data.html.querySelector('variant-description-component');

    if (!newDescription) {
      this.hidden = true;
      this.refs.content.innerHTML = '';
      return;
    }

    const newContent = newDescription.querySelector('[ref="content"]');
    const hasContent = !!newContent?.innerHTML?.trim();

    this.hidden = !hasContent;
    this.refs.content.innerHTML = hasContent ? newContent.innerHTML : '';
  };
}

if (!customElements.get('variant-description-component')) {
  customElements.define('variant-description-component', ProductVariantDescription);
}
